export const animationBannerVariant = {
  initial: { gridTemplateColumns: '30% 70%' },
  animate: { gridTemplateColumns: '50% 50%' }
};

export const textTransition = {
  duration: 0.5,
  ease: 'easeOut',
  delay: 0
};

export const textVariants = {
  hidden: {
    opacity: 0,
    x: 50,
    transition: textTransition
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: textTransition
  }
};

export const textContainerVariant = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1 }
  }
};

export const imageVariants = {
  initial: {
    opacity: 0.8
  },
  animate: {
    opacity: 1
  }
};

export const imageTransitionVariant = { duration: 1, ease: 'linear' };
